import React from 'react';
import { StoreSetupAutomation } from '../../types/storeSetup.types';
import { SetupBeat } from './setupDraft';
import { setupOn } from './setupPreviewModel';

type Props = {
  automations: StoreSetupAutomation[];
  beat: SetupBeat | null;
};

function stepsOf(item: StoreSetupAutomation): Array<{ kind: string; label: string }> {
  const steps = [
    { kind: 'Quand', label: item.trigger.label },
    ...item.criteria.slice(0, 2).map((rule) => ({
      kind: 'Si',
      label: rule.label || rule.values[0] || rule.fieldId
    })),
    ...item.actions.slice(0, 2).map((action) => ({
      kind: 'Alors',
      label: action.label
    }))
  ];
  return steps.filter((step) => step.label);
}

const SetupFlow: React.FC<Props> = ({ automations, beat }) => (
  <div className="setup-flow">
    {automations.map((item) => (
      <article
        key={item.id}
        data-setup-id={item.id}
        className={`setup-flow__card${setupOn(item.id, beat)}`}
      >
        <header>
          <strong>{item.name}</strong>
          <span>Inactive</span>
        </header>
        <div className="setup-flow__track">
          {stepsOf(item).map((step, index) => (
            <React.Fragment key={`${item.id}-${step.kind}-${index}`}>
              {index > 0 ? <span className="setup-flow__arrow" aria-hidden="true">→</span> : null}
              <div>
                <small>{step.kind}</small>
                {step.label}
              </div>
            </React.Fragment>
          ))}
        </div>
      </article>
    ))}
  </div>
);

export default SetupFlow;
